export const sha256Hex = async (value: string): Promise<string> => {
  const hashedValue = await crypto.subtle.digest(
    'SHA-256',
    new TextEncoder().encode(value)
  );

  return Array.from(new Uint8Array(hashedValue))
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');
};
